import { useRef, useLayoutEffect } from 'react'

export default function useCallbackRef<T extends unknown[], R>(
  callback: ((...args: [...T]) => R) | undefined,
) {
  const callbackRef = useRef<((...args: [...T]) => R) | undefined>(callback)

  useLayoutEffect(() => {
    callbackRef.current = callback
  }, [callback])

  return callbackRef
}
